import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import Axios from "axios";
import Notifications from "vue-notification";
import VSelect from "vue-select";
import "./directives/outsideClickHandler";
import router from "./router";
import store from "./store/index";
import App from "./App.vue";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import VueCurrencyInput from "vue-currency-input";
import VueNumeric from "vue-numeric";
import VueMask from "v-mask";
import VueTheMask from "vue-the-mask";
import * as VueGoogleMaps from "vue2-google-maps"
import JsonCSV from 'vue-json-csv'
import { authToken } from "./servico/aiHttp";
Vue.use(VueTheMask);

const pluginOptions = {
  globalOptions: { currency: "BRL" }
};
Vue.use(VueCurrencyInput, pluginOptions);
Vue.use(VueNumeric);
Vue.use(VueMask);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBdCF7IwBMCvFSWGANRHDtQxnlfiD9iUAA",
    libraries: "places" // necessary for places input
  }
});

var axiosInstance = Axios.create({
  baseURL: store.getters.baseURL
});

// declare a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      localStorage.removeItem("user-token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// Authorization resolvido a cada requisição: fixá-lo na carga do módulo
// deixava o header com o token da sessão anterior depois de um login em outra
// conta na mesma aba (sem reload).
axiosInstance.interceptors.request.use((config) => {
  const token = authToken();
  if (token) {
    config.headers["Authorization"] = "bearer " + token;
  } else {
    delete config.headers["Authorization"];
  }
  return config;
});

Vue.prototype.$http = axiosInstance;

Vue.use(CoreuiVue);
Vue.use(BootstrapVue);

Vue.use(Notifications);
Vue.component("v-select", VSelect);
Vue.use(HighchartsVue);
Vue.use(Highcharts);
Vue.component('downloadCsv', JsonCSV)

Vue.directive('permission', {
  inserted(el, binding, vnode) {
    if (
      store.getters.getAutenticacao.permissoes.filter(
        (x) => x === binding.value
      ).length <= 0) {
      vnode.elm.parentElement.removeChild(vnode.elm)
    }
  }
})

Vue.config.productionTip = false;

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next("/login");
      return;
    }
    if (
      to.meta.permission &&
      store.getters.getAutenticacao.permissoes.filter(
        (x) => x === to.meta.permission
      ).length <= 0
    ) {
      next("/sem-permissao");
      return;
    }
    if (to.meta.requiresPmau) {
      if (store.state.main.pmauHabilitado === null) {
        await store.dispatch("fetchPmauAccess");
      }
      if (!store.state.main.pmauHabilitado) {
        next("/dashboard");
        return;
      }
    }
    if (to.meta.requiresPmauAdmin || to.meta.pmauModules) {
      if (store.state.main.pmauModules === null) {
        await store.dispatch("fetchPmauPermissions");
      }
      if (to.meta.requiresPmauAdmin && !store.state.main.pmauAdmin) {
        next("/dashboard");
        return;
      }
      // Módulos do PMAU (Permissões PMAU): basta ter um dos listados na rota.
      if (to.meta.pmauModules && !store.getters.hasPmauModule(...to.meta.pmauModules)) {
        next("/dashboard");
        return;
      }
    }
    next();
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  icons,
  render: (h) => h(App)
}).$mount("#app");
